import organizations from "@/apis/coreIAM/organizations"
import { organizationsTypes } from "@/store/mutationTypes"

export default {
    state: {
        concepts: [],
        fetchAllConcepts: {
            pending: false,
            error: null,
        },
        addConcept: {
            pending: false,
            error: null,
        },
        removeConcept: {
            pending: false,
            error: null,
        },
        fetchOrganizationConceptUsers: {
            pending: false,
            error: null,
        },
        addOrganizationConceptUser: {
            pending: false,
            error: null,
        },
        removeOrganizationConceptUser: {
            pending: false,
            error: null,
        }
    },
    mutations: {
        [organizationsTypes.FETCH_ALL_CONCEPTS_REQUEST]: function (state) {
            state.fetchAllConcepts.pending = true;
        },
        [organizationsTypes.FETCH_ALL_CONCEPTS_SUCCESS]: function (state, concepts) {
            state.concepts = concepts;
            state.fetchAllConcepts.error = null;
            state.fetchAllConcepts.pending = false
        },
        [organizationsTypes.FETCH_ALL_CONCEPTS_FAILURE]: function (state, error) {
            state.fetchAllConcepts.error = error;
            state.fetchAllConcepts.pending = false;
        },
        [organizationsTypes.ADD_CONCEPT_REQUEST]: function (state) {
            state.addConcept.pending = true;
        },
        [organizationsTypes.ADD_CONCEPT_SUCCESS]: function (state) {
            state.addConcept.error = null;
            state.addConcept.pending = false;
        },
        [organizationsTypes.ADD_CONCEPT_FAILURE]: function (state, error) {
            state.addConcept.error = error;
            state.addConcept.pending = false;
        },
        [organizationsTypes.REMOVE_CONCEPT_REQUEST]: function (state) {
            state.removeConcept.pending = true;
        },
        [organizationsTypes.REMOVE_CONCEPT_SUCCESS]: function (state) {
            state.removeConcept.error = null;
            state.removeConcept.pending = false;
        },
        [organizationsTypes.REMOVE_CONCEPT_FAILURE]: function (state, error) {
            state.removeConcept.error = error;
            state.removeConcept.pending = false;
        },
        [organizationsTypes.FETCH_CONCEPT_USERS_REQUEST]: function (state) {
            state.fetchOrganizationConceptUsers.pending = true;
        },
        [organizationsTypes.FETCH_CONCEPT_USERS_SUCCESS]: function (state) {
            state.fetchOrganizationConceptUsers.error = null;
            state.fetchOrganizationConceptUsers.pending = false;
        },
        [organizationsTypes.FETCH_CONCEPT_USERS_FAILURE]: function (state, error) {
            state.fetchOrganizationConceptUsers.error = error;
            state.fetchOrganizationConceptUsers.pending = false;
        },
        [organizationsTypes.ADD_CONCEPT_USER_REQUEST]: function (state) {
            state.addOrganizationConceptUser.pending = true;
        },
        [organizationsTypes.ADD_CONCEPT_USER_SUCCESS]: function (state) {
            state.addOrganizationConceptUser.error = null;
            state.addOrganizationConceptUser.pending = false;
        },
        [organizationsTypes.ADD_CONCEPT_USER_FAILURE]: function (state, error) {
            state.addOrganizationConceptUser.error = error;
            state.addOrganizationConceptUser.pending = false;
        },
        [organizationsTypes.REMOVE_CONCEPT_USER_REQUEST]: function (state) {
            state.removeOrganizationConceptUser.pending = true;
        },
        [organizationsTypes.REMOVE_CONCEPT_USER_SUCCESS]: function (state) {
            state.removeOrganizationConceptUser.error = null;
            state.removeOrganizationConceptUser.pending = false;
        },
        [organizationsTypes.REMOVE_CONCEPT_USER_FAILURE]: function (state, error) {
            state.removeOrganizationConceptUser.error = error;
            state.removeOrganizationConceptUser.pending = false;
        },
    },
    actions: {
        async fetchAllConcepts({ commit }, payload) {
            commit(organizationsTypes.FETCH_ALL_CONCEPTS_REQUEST)
            return new Promise((resolve, reject) => {
                organizations
                    .getOrganizationConcepts(payload.organizationUuid)
                    .then((concepts) => {
                        commit(organizationsTypes.FETCH_ALL_CONCEPTS_SUCCESS, concepts.data)
                        resolve(concepts.data)
                    }).catch((error) => {
                        commit(organizationsTypes.FETCH_ALL_CONCEPTS_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async addConcept({ commit }, payload) {
            commit(organizationsTypes.ADD_CONCEPT_REQUEST)
            return new Promise((resolve, reject) => {
                organizations
                    .addOrganizationConcept(payload.organizationUuid, payload.conceptUuid)
                    .then((concept) => {
                        commit(organizationsTypes.ADD_CONCEPT_SUCCESS)
                        resolve(concept.data)
                    })
                    .catch((error) => {
                        commit(organizationsTypes.ADD_CONCEPT_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async removeConcept({ commit }, payload) {
            commit(organizationsTypes.REMOVE_CONCEPT_REQUEST)
            return new Promise((resolve, reject) => {
                organizations
                    .removeOrganizationConcept(payload.organizationUuid, payload.conceptUuid)
                    .then(() => {
                        commit(organizationsTypes.REMOVE_CONCEPT_SUCCESS)
                        resolve()
                    })
                    .catch(error => {
                        commit(organizationsTypes.REMOVE_CONCEPT_FAILURE)
                        reject(error)
                    })
            })
        },
        async fetchOrganizationConceptUsers({ commit }, payload) {
            commit(organizationsTypes.FETCH_LOCATION_USERS_REQUEST)
            return new Promise((resolve, reject) => {
                organizations
                    .listOrganizationConceptUsers(payload.organizationUuid, payload.conceptUuid)
                    .then((users) => {
                        commit(organizationsTypes.FETCH_LOCATION_USERS_SUCCESS)
                        resolve(users.data)
                    })
                    .catch(error => {
                        commit(organizationsTypes.FETCH_LOCATION_USERS_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async addOrganizationConceptUser({ commit }, payload) {
            commit(organizationsTypes.ADD_LOCATION_USER_REQUEST)
            return new Promise((resolve, reject) => {
                organizations
                    .addOrganizationConceptUser(payload.organizationUuid, payload.conceptUuid, payload.userUuid, payload.role)
                    .then(() => {
                        commit(organizationsTypes.ADD_LOCATION_USER_SUCCESS)
                        resolve()
                    })
                    .catch(error => {
                        commit(organizationsTypes.ADD_LOCATION_USER_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async removeOrganizationConceptUser({ commit }, payload) {
            commit(organizationsTypes.REMOVE_LOCATION_USER_REQUEST)
            return new Promise((resolve, reject) => {
                organizations
                    .removeOrganizationConceptUser(payload.organizationUuid, payload.conceptUuid, payload.userUuid, payload.role)
                    .then(() => {
                        commit(organizationsTypes.REMOVE_LOCATION_USER_SUCCESS)
                        resolve()
                    })
                    .catch(error => {
                        commit(organizationsTypes.REMOVE_LOCATION_USER_FAILURE, error)
                        reject(error)
                    })
            })
        },
    }
}